import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHomeassistantComponent } from './simple-icons-homeassistant.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHomeassistantComponent ],
    exports:      [ SimpleIconsHomeassistantComponent ],
    bootstrap:    []
})
export class SimpleIconsHomeassistantModule {}
